import { io } from 'socket.io-client';
import { getPosClientIdFromStorage } from '@/utils/socketUtils';

const env = process.env;
const serverUrl =
  env.VUE_APP_MODE === "development"
    ? env.VUE_APP_BROADCAST_SERVER_DEV_URL
    : env.VUE_APP_BROADCAST_SERVER_URL;

export const socket = io(serverUrl, {
  transports: ['websocket'],
});

export const socketService = {
  /**
   * Emit a 'register' event with the given clientId.
   * If clientId is not passed as parameter, it'll pull from storage.
   */
  registerClient(clientId = null) {
    const id = clientId || getPosClientIdFromStorage();
    if (id) {
      socket.emit('register', id);
    } else {
      console.warn('No clientId available to register.');
    }
  },
  broadcastMessage(keyCode, payload = null, targetId = null) {
    if (!targetId) {
      socket.emit(keyCode, payload);
    } else {
      socket.emit(keyCode, {
        targetId,
        data: payload,
      });
    }
  },
  listen(keyCode, callback) {
    socket.on(keyCode, callback);
  },
  removeListener(keyCode, callback = null) {
    socket.off(keyCode, callback);
  },
  disconnect() {
    socket.disconnect();
  },
};
    